<template>
  <div
    class="photo-container"
    :class="{ video: !isPhoto }"
    @click="openGallery"
  >
    <div class="photo-wrapper">
      <template v-if="isPhoto">
        <img
          v-lazy="photoUrl"
          class="photo-wrapper__photo"
          width="300"
          title="Open fullscreen gallery view"
        />
      </template>
      <template v-else-if="photo.attributes.video_processing">
        <div class="processing">This video is currently processing</div>
      </template>
      <!-- An <img>, not a <video>: this never had controls, the click opens the
           gallery, and the play icon is CSS on .photo-container.video. A <video>
           costs a media element even at preload="none", and the QA report renders
           twelve of them before anyone opens a gallery. -->
      <img
        v-else
        :src="cdnUrl(photo.attributes.video_thumb)"
        class="photo-wrapper__poster"
        width="300"
        title="Open fullscreen gallery view"
      />
      <v-tooltip
        v-if="hasCaption"
        top
        content-class="info-tooltip"
        class="caption"
      >
        <div slot="activator" class="fa-solid fa-comment icon" />
        {{ photo.attributes.caption }}
      </v-tooltip>

      <v-tooltip v-if="isPano" top content-class="info-tooltip" class="pano">
        <div
          slot="activator"
          class="fa-solid fa-cube icon"
          style="cursor: pointer"
        />
        360 Photo
      </v-tooltip>
    </div>
    <div v-if="label" class="photo-label" :style="{ color: labelColor }">
      {{ label }}
    </div>
  </div>
</template>

<script>
import { replaceWithCdnUrl } from '@/utils/cdnHelper'

export default {
  // eslint-disable-next-line vue/require-prop-types
  props: ['photo', 'photoIndex', 'label', 'labelColor'],
  computed: {
    hasCaption() {
      return (this.photo.attributes.caption || '').length > 0
    },
    isPano() {
      return this.photo.attributes.is_pano
    },
    isPhoto() {
      return !this.photo.attributes.video
    },
    photoUrl() {
      return this.cdnUrl(
        this.photo.attributes.photo || this.photo.attributes.image
      )
    },
  },
  methods: {
    openGallery() {
      this.$emit('openGallery', { index: this.photoIndex, photo: this.photo })
    },
    cdnUrl(url) {
      return replaceWithCdnUrl(url) || url
    },
  },
}
</script>
<style lang="scss" scoped>
.photo-container {
  height: 100%;
  width: 100%;
  display: flex;
  align-items: center;
  align-content: center;
  justify-content: center;
  position: relative;
  background-color: #fff;

  &.video {
    transition: opacity 0.1s linear;
    cursor: pointer;
    &:after {
      font-family: 'Font Awesome 6 Free';
      content: '\f144';
      color: white;
      font-size: 4rem;
      position: absolute;
      top: 50%;
      left: 50%;
      z-index: 2;
      text-align: center;
      transform: translate(-50%, -50%);
      text-shadow: 1px 1px 3px #000;
    }
  }
  &.video:hover {
    opacity: 0.8;
  }

  .photo-wrapper {
    max-height: 100%;
    position: relative;

    &__photo {
      width: 300px;
      background-color: rgba(0, 0, 0, 0.025);
    }

    // Same box the <video> occupied, so the card layout does not shift.
    &__poster {
      width: 300px;
      height: 200px;
      object-fit: cover;
      cursor: pointer;
    }
  }
}

.tooltip-container {
  position: relative;
}

.processing {
  width: 100%;
  display: flex;
  align-items: center;
  height: 100%;
  justify-content: center;
  color: #fff;
  background-color: rgba(0, 0, 0, 0.75);
}

img {
  transition: opacity 0.1s linear;

  &:hover {
    cursor: zoom-in;
    opacity: 0.8;
  }
}

// The video thumbnail opens the gallery rather than zooming, so it keeps the
// pointer the container sets.
.photo-wrapper__poster:hover {
  cursor: pointer;
}

.caption,
.pano {
  position: absolute;
  .icon {
    font-size: 1.25em;
    color: #fff;
    text-shadow: 1px 1px 1px #333333;
  }
}

.caption {
  position: absolute;
  left: 0.75em;
  bottom: 0.75em;
}

.pano {
  right: 0.75em;
  bottom: 0.75em;
}

.photo-label {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  font-size: 0.7em;
  font-weight: 600;
  text-align: center;
  padding: 0.25em 0;
  line-height: 1;
  background: rgba(255, 255, 255, 0.85);
}
</style>
